import React, { Component } from 'react';
import { Container, Row, Col, CardDeck, Card, CardBody, CardFooter, CardHeader, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBolt, faCheck, faTachometerAlt } from '@fortawesome/free-solid-svg-icons'

class Techinsert extends Component {
    render() {
        return(
            <Container>
            <Row className="my-5">
                <div className="col-md-2 col-4 d-flex align-items-center">
                    <img src="https://res.cloudinary.com/stormdragon-designs/image/upload/e_make_transparent:32/v1529140577/1_kt9otqHk14BZIMNruiG0BA_mmeuw9.png" alt="react-logo" className="img-fluid align-middle"/>
                </div>
                <div className="col-md-2 col-4 d-flex align-items-center">
                    <img src="https://res.cloudinary.com/stormdragon-designs/image/upload/v1529140965/1_vBw9_VPFiEcxgxDx-Oghzw_cwltqn.png" alt="nodejs-logo" className="img-fluid align-middle"/>
                </div>
                <div className="col-md-2 col-4 d-flex align-items-center">
                    <img src="https://res.cloudinary.com/stormdragon-designs/image/upload/c_crop,h_331,w_1165/v1529141206/0_DigfG6xRmNAuJ2To_thbvrd.png" alt="firebase-logo" className="img-fluid align-middle"/>
                </div>
                <div className="col-md-2 col-4 d-flex align-items-center">
                    <img src="https://res.cloudinary.com/stormdragon-designs/image/upload/c_crop,h_160,w_436/v1529141461/golang-card_ahjdti.png" alt="golang-logo" className="img-fluid align-middle"/>
                </div>
                <div className="col-md-2 col-4 d-flex align-items-center">
                    <img src="https://res.cloudinary.com/stormdragon-designs/image/upload/c_crop,h_101,w_477/v1529141564/cloudinary_logo_for_white_bg_rhq4io.png" alt="cloudinary-logo" className="img-fluid align-middle"/>
                </div>
                <div className="col-md-2 col-4 d-flex align-items-center">
                    <img src="https://res.cloudinary.com/stormdragon-designs/image/upload/c_crop,h_250,w_724/v1529141699/cf-blog-logo-crop_mzmlop.png" alt="cloudflare-logo" className="img-fluid align-middle"/>
                </div>
            </Row>
            <hr />
            <Row className="justify-content-center text-center">
                <Col md="auto" className="py-5">
                    <h2>We use modern tools to craft a modern web.</h2>
                </Col>
            </Row>
            <Row className="justify-content-center text-center">
                <Col md="auto" className="pb-5">
                    <h4>Our web development and design packages come with everything you need.</h4>
                </Col>
            </Row>
            <CardDeck>
                <Card className="col-md-4 text-center px-0 pt-2">
                    <CardHeader className="bg-transparent">
                        <FontAwesomeIcon icon={faBolt} className="display-4 pb-4" /><br />
                        <CardTitle>Lightning fast</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <p>
                            We use a combination of high-performance servers and content delivery networks to get your business in front of your customer as fast as possible.
                        </p>
                        <p>
                            Our sites load quick. How quick? 
                        </p>
                    </CardBody>
                    <CardFooter>
                        <strong className="h5">Under 2 Seconds Load Time<sup>*</sup></strong>
                    </CardFooter>
                </Card>
                <Card className="col-md-4 text-center px-0 pt-2">
                    <CardHeader className="bg-transparent">
                        <FontAwesomeIcon icon={faCheck} className="display-4 pb-4" /><br />
                        <CardTitle>Continuous monitoring</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <p>
                            Our sites are monitored 24/7 to make sure your website or app stays available at all times. We also provide an uptime page for your website so you can keep an eye on it.
                        </p>
                    </CardBody>
                    <CardFooter>
                        <strong className="h5">99.9% Uptime SLA<sup>^</sup></strong>
                    </CardFooter>
                </Card>
                <Card className="col-md-4 text-center px-0 pt-2">
                    <CardHeader className="bg-transparent">
                        <FontAwesomeIcon icon={faTachometerAlt} className="display-4 pb-4" /><br />
                        <CardTitle>Scales with you</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <p>
                            Our websites are designed to scale, so whether you have a hundred users or a hundred thousand, our apps will continue to work quickly and reliably.
                        </p>
                        <p>
                            Our hosting is charged for what you use, so you always get the best price.
                        </p>
                    </CardBody>
                    <CardFooter>
                        <strong className="h5">Pay As You Go Hosting<sup>&dagger;</sup></strong>
                    </CardFooter>
                </Card>
            </CardDeck>
            <div className="my-5"></div>
        </Container>
        )
    }
}

export default Techinsert;


// WEBPACK FOOTER //
// ./src/components/Techinsert.js